var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 23,
    viewBox: "0 0 17 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.499 17.3396L15.0683 15.9089V10.3636C15.0683 6.95874 13.2494 4.10844 10.0775 3.35428V2.60012C10.0775 1.6796 9.33441 0.936523 8.41388 0.936523C7.49336 0.936523 6.75029 1.6796 6.75029 2.60012V3.35428C3.56728 4.10844 1.7595 6.94765 1.7595 10.3636V15.9089L0.328812 17.3396C-0.369898 18.0383 0.11809 19.2361 1.10516 19.2361H15.7115C16.7097 19.2361 17.1977 18.0383 16.499 17.3396ZM12.851 17.0182H3.97852V10.3638C3.97852 7.61336 5.6532 5.37305 8.41477 5.37305C11.1763 5.37305 12.851 7.61336 12.851 10.3638V17.0182ZM8.41442 22.5629C9.63439 22.5629 10.6325 21.5647 10.6325 20.3447H6.19629C6.19629 21.5647 7.18336 22.5629 8.41442 22.5629Z",
    fill: "#111111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.23af48045497315f4cf608f8c4cc84c5.svg";
export { ForwardRef as ReactComponent };